import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Box, TextField, Button, Typography, Alert
} from "@mui/material";
import { confirmPasswordReset } from "../api/users";
import { useTranslation } from "react-i18next";

const ResetPasswordPage = () => {
    const { t } = useTranslation("common");
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);

        if (password !== confirm) {
            setError(t("resetPassword.mismatch"));
            return;
        }

        try {
            setLoading(true);
            await confirmPasswordReset(token, password);
            setMessage(t("resetPassword.success"));
            setTimeout(() => navigate("/login"), 3000);
        } catch (err) {
            setError(err.message || t("resetPassword.error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
            }}
        >
            <Box sx={{
                maxWidth: 400,
                width: "100%",
                p: 4,
                boxShadow: 3,
                borderRadius: 2,
                backgroundColor: "white"
            }}>
                <Typography variant="h5" fontWeight="bold" mb={3} textAlign="center">
                    {t("resetPassword.title")}
                </Typography>

                {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        label={t("resetPassword.newPassword")}
                        type="password"
                        fullWidth
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label={t("resetPassword.confirmPassword")}
                        type="password"
                        fullWidth
                        required
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <Button type="submit" variant="contained" fullWidth disabled={loading}>
                        {loading ? t("resetPassword.saving") : t("resetPassword.submit")}
                    </Button>
                </form>
            </Box>
        </Box>
    );
};

export default ResetPasswordPage;
